import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useProjects } from '@/features/projects/api/projects';

import type { EstatesFiltersSchemaType } from '../schemas';
import { SelectController } from '@/components/form/controllers/select-controller';
import { cn } from '@/lib/utils';
import {
  activeFilterFieldClassName,
  activeFilterInputClassName,
  hasActiveFilterValue,
} from './estate-filter-active-field';

export const EstateFilterProject = () => {
  const { t } = useTranslation();

  const { data: projects } = useProjects({ query: { filters: { hasEstates: true } } });

  const projectOptions =
    projects?.map((project) => ({
      title: project.name || `Project_${project.id}`,
      id: project.id,
    })) || [];

  const methods = useFormContext<EstatesFiltersSchemaType>();
  const projectId = methods.watch('projectId');

  return (
    <fieldset className="mb-5 grid grid-cols-1 gap-4">
      <div className="border-t border-[hsl(214.3_31.8%_91.4%)]" />
      <SelectController
        wrapperClassName={cn(hasActiveFilterValue(projectId) && activeFilterFieldClassName)}
        label={t('project')}
        placeholder={t('selectProject')}
        size="sm"
        color="neutral"
        className={cn(
          'h-8 w-full bg-white text-[#768295] hover:border-[#07B4C0] [&_svg]:text-[#2F3A4A]',
          hasActiveFilterValue(projectId) && activeFilterInputClassName
        )}
        options={projectOptions}
        methods={methods}
        name="projectId"
      />
    </fieldset>
  );
};
